// Only what Bootstrap cannot do: the overlord's flex-basis-zero sizing has no utility
// equivalent, and TinyMCE-built elements can only be reached through :global. Header display,
// wrap, alignment and colour ride Bootstrap utilities added via classList in the SkinLoaded
// handler instead (RichTextInput.tsx) — their `!important` beats the skin's own non-important
// `.tox-editor-header` rule with no specificity trick needed. A wrapping flex row (not the
// skin's grid): on an editor narrower than both slots plus the toolbar, the end slot moves to
// a second row instead of being clipped by the container's overflow hidden. Slot menus portal
// to document.body by default, so no z-index here.
.withToolbarSlots:global(.tox.tox-tinymce) :global(.tox-toolbar-overlord) {
  flex: 1 1 0;
  min-width: 3rem;
}
